<template>
  <v-layout id="user-menu" align-center justify-end ma-0>
    <v-flex sm4 class="mobile-smart">
      <nuxt-link
        :to="smartLink"
        title="הסוכנת החכמה"
        class="v-btn v-btn--text text"
        id="mobile-smart-btn"
      >
        <img src="@/assets/23/avatar.svg" alt="" width="40"/>
      </nuxt-link>
    </v-flex>

    <v-flex>
      <UserFavourites />
    </v-flex>

    <v-flex pa-0>
      <div id="user-menu-wrapper">
        <UserLogin />
      </div>
    </v-flex>
    <v-flex hidden-sm-and-down>
      <PublishJob />
    </v-flex>
  </v-layout>
</template>

<script>
import UserFavourites from '@/components/NavigationMenu/UserMenu/UserFavourites/UserFavourites.vue';
import UserLogin from '@/components/NavigationMenu/UserMenu/UserLogin.vue';
import PublishJob from '@/components/NavigationMenu/UserMenu/PublishJob/PublishJob.vue';
import CurrentUser from '@/components/mixins/CurrentUser';

export default {
  mixins: [CurrentUser],
  components: {
    UserFavourites,

    UserLogin,
    PublishJob,
  },
  computed: {
    smartLink() {
      if (this.CurrentUser && this.SmartAgentActive) {
        return '/personal/smartalertsnotification/';
      } else {
        return '/smartalerts.aspx';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-smart {
  display: none;
}

// #user-menu {

// }
#user-menu .flex {
  padding: 0 !important;
}

#user-menu-wrapper {
  position: relative;
  min-width: 64px;
}

@media screen and (max-width: 1280px) {
  #user-menu-wrapper {
    min-width: 45px;
  }
  .mobile-smart {
    display: block;
  }
  a#mobile-smart-btn {
    display: flex;
  }

  #user-menu {
    margin: 0;
  }
}
@media screen and (max-width: 600px) {
  #user-menu {
    margin-top: 0px !important;
  }
}
</style>
